// ============================================================================
// sheep.dailys.detail — migrated off the global read
// ============================================================================
// The /sheep/dailys/<id> record page owns its keyed report and shared feed
// inputs through sheep.daily.detail. Its record id is part of the resource key,
// so moving between daily reports is a key change rather than a local reload.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'sheep.dailys.detail',
  obligations: Object.freeze([Object.freeze({id: 'sheep.daily.detail', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
